var Shopify = Shopify || {};

Shopify.formatMoney = function (cents, format = Shopify.money_format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/*==============================
 PI Local Storage
  ==============================*/

class PIStorage {
  constructor(key, days = 7) {
    this.key = key;
    this.days = days;
  }

  set(value) {
    const now = new Date();
    const expiry = now.getTime() + this.days * 24 * 3600 * 1000;
    const item = {
      expiry: expiry,
      value: value,
    };
    localStorage.setItem(this.key, JSON.stringify(item));
  }

  get() {
    const now = new Date();
    const itemStr = localStorage.getItem(this.key);
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(this.key);
      return null;
    }
    return item.value;
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = "__";

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(
    oldNode,
    newContent,
    preProcessCallbacks = [],
    postProcessCallbacks = []
  ) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          "form",
          `${element.form.getAttribute("id")}-${uniqueKey}`
        );
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min)
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)").matches) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === "") {
        const productUrl = this.dataset.url.split("?")[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            const sourceQty = html.querySelector(
              ".quick-order-list-container"
            ).parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(
        `#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`
      )
    );
  }
}

customElements.define("bulk-modal", BulkModal);


class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);



class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dotsDiv = this.querySelector(".pi-slider-dots");

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.renderDots();
    this.update();
  }

  renderDots() {
    var html = "";
    for (var i = 1; i <= this.totalPages; i++) {
      html += '<span class="pi-slider-dot" data-index="' + i + '"></span>';
    }
    if (this.dotsDiv) {
      this.dotsDiv.innerHTML = html;
    }
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    if (this.dotsDiv) {
      this.dotsDiv.querySelectorAll(".pi-slider-dot").forEach((dot) => {
        dot.classList.remove("active");
      });
      this.dotsDiv
        .querySelector(`[data-index="${this.currentPage}"]`)
        .classList.add("active");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute("selected"))
        .removeAttribute("selected");
      target.selectedOptions[0].setAttribute("selected", "selected");

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest(".product-form__input")
        .querySelector("[data-selected-value] > .swatch");
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset"
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }

      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
      );
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = target
        .closest(`.product-form__input`)
        .querySelector("[data-selected-value]");
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked")
    ).map(({ dataset }) => dataset.optionValueId);
  }
}

customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px 400px 0px" }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
        }

        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector(".icon");
  }

  connectedCallback() {
    document.addEventListener(
      "storefront:signincompleted",
      this.handleStorefrontSignInCompleted.bind(this)
    );
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define("account-icon", AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter(
      (queueElement) => !queue.includes(queueElement)
    );
    const quickBulkElement =
      this.closest("quick-order-list") || this.closest("quick-add-bulk");
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.min_error.replace(
          "[min]",
          event.target.dataset.min
        )
      );
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.max_error.replace(
          "[max]",
          event.target.max
        )
      );
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.step_error.replace(
          "[step]",
          event.target.step
        )
      );
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

if (!customElements.get("bulk-add")) {
  customElements.define("bulk-add", BulkAdd);
}

class InfinityScroll extends HTMLElement {
  constructor() {
    super();
    this.offset = 400;
    this.loading = false;
    this.container = "[data-pi-infinity-scroll-container]";
    this.sectionId = this.dataset.sectionId;
    this.handleScroll = this.onScroll.bind(this);
    // this.setAttribute("hidden", true);
  }

  connectedCallback() {
    this.initWhenVisible({
      element: this,
      callback: this.handleScroll,
      threshold: 50,
    });
  }

  onScroll() {
    // console.log("Visible");
   
    const gridProducts = document.querySelectorAll("#product-grid .grid__item");
    if (gridProducts.length < 12) {
      this.setAttribute("hidden", true);
      return false;
    }

    this.nextPageUrl = this.getAttribute("data-next-page");
    if (this.loading) return false;

    if (this.nextPageUrl === "" || this.nextPageUrl === null) {
      // console.log("NO MORE PRODUCTS TO FETCH");
      this.setAttribute("hidden", true);
      document.removeEventListener("scroll", this.handleScroll);
      return false;
    } else {
      this.removeAttribute("hidden");
    }
    this.fetchMore();
  }

  fetchMore() {
    console.log("Fetching more products");
    var url = new URL(this.nextPageUrl);
    url.searchParams.append("section_id", this.sectionId);

    this.loading = true;

    fetch(url)
      .then((response) => response.text())
      .then((htmlText) => {
        var html = new DOMParser().parseFromString(htmlText, "text/html");
        const container = document.querySelector(this.container);
        const products = html.querySelector(this.container);

        window.history.replaceState(
          { path: this.nextPageUrl },
          "",
          this.nextPageUrl
        );

        if (container && products) {
          container.insertAdjacentHTML("beforeend", products.innerHTML);
        }

        const newNextPage = html
          .querySelector("infinity-scroll")
          ?.getAttribute("data-next-page");

        if (newNextPage) {
          this.setAttribute("data-next-page", newNextPage);
        } else {
          this.setAttribute("data-next-page", "");
          this.setAttribute("hidden", true);
          document.removeEventListener("scroll", this.handleScroll);
        }
      })
      .catch((error) => {
        console.error("Error fetching more products:", error);
        this.setAttribute("hidden", true);
        document.removeEventListener("scroll", this.handleScroll);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0;
    var observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (typeof options.callback === "function") {
              options.callback();
              // observer.unobserve(entry.target);
            }
          }
        });
      },
      { rootMargin: "0px 0px " + threshold + "px 0px" }
    );

    observer.observe(options.element);
  };
}

customElements.define("infinity-scroll", InfinityScroll);

class InfinityClick extends HTMLElement {
  constructor() {
    super();
    this.loading = false;
    this.container = "[data-pi-infinity-scroll-container]";
    this.productItem = "#product-grid .grid__item";
    this.sectionId = this.dataset.sectionId;
    this.handleClick = this.onClick.bind(this);
  }

  connectedCallback() {
    // this.setupButton();
    this.addEventListener("click", this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
  }

  // setupButton() {
  //   this.textContent = this.dataset.loadMoreText || 'Load More';
  //   this.classList.add('infinity-scroll-button button button--primary');
  //   this.updateButtonVisibility();
  // }

  updateButtonVisibility() {
    const hasNextPage = this.dataset.nextPage && this.dataset.nextPage !== "";
    this.style.display = hasNextPage ? "block" : "none";
  }

  onClick() {
    if (this.loading) return;
    this.fetchMore();
  }

  fetchMore() {
    const nextPageUrl = this.dataset.nextPage;
    if (!nextPageUrl) {
      this.style.display = "none";
      return;
    }

    const url = new URL(nextPageUrl);
    // url.searchParams.set('section_id', this.sectionId);
    this.loading = true;
    this.classList.add("loading");

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const container = document.querySelector(this.container);
        const newProducts = html.querySelector(this.container);

        if (container && newProducts) {
          container.insertAdjacentHTML("beforeend", newProducts.innerHTML);
          this.updateNextPageUrl(html);
        }

        window.history.replaceState({ path: url.toString() }, "", url);
      })
      .catch((e) => console.error("Error fetching more products:", e))
      .finally(() => {
        this.loading = false;
        this.classList.remove("loading");
        this.updateButtonVisibility();
        this.dispatchEvent(new CustomEvent("products-loaded"));
      });
  }

  updateNextPageUrl(html) {
    const nextInfinityClick = html.querySelector("infinity-click");
    if (nextInfinityClick) {
      this.dataset.nextPage = nextInfinityClick.dataset.nextPage;
    } else {
      this.dataset.nextPage = "";
    }
  }
}

customElements.define("infinity-click", InfinityClick);


///

// announcement bar on click close

// const bannerClose = document.querySelector(".pi-utility-bar__close");
// bannerClose.addEventListener("click", function () {
//   this.parentElement.classList.add("pi-hidden");
//   document.documentElement.style.setProperty("--pi-utility-bar-height", `0px`);
// });

document.addEventListener("DOMContentLoaded", function () {
  const detailsElements = document.querySelectorAll(
    ".pi-header__megamenu-wrapper details"
  );

  detailsElements.forEach(function (details) {
    details.addEventListener("mouseover", function () {
      this.setAttribute("open", "");
      this.querySelector("summary").setAttribute("aria-expanded", "true");
    });

    details.addEventListener("mouseout", function () {
      this.removeAttribute("open");
      this.querySelector("summary").setAttribute("aria-expanded", "false");
    });
  });
});

/// /// ////

class VerticalSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dotsDiv = this.querySelector(".pi-slider-dots");

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
    this.slidesPerPage = Math.floor(
      (this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.renderDots();
    this.update();
  }

  renderDots() {
    var html = "";
    for (var i = 1; i <= this.totalPages; i++) {
      html += '<span class="pi-slider-dot" data-index="' + i + '"></span>';
    }
    if (this.dotsDiv) {
      this.dotsDiv.innerHTML = html;
    }
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    if (this.dotsDiv) {
      this.dotsDiv.querySelectorAll(".pi-slider-dot").forEach((dot) => {
        dot.classList.remove("active");
      });
      this.dotsDiv
        .querySelector(`[data-index="${this.currentPage}"]`)
        .classList.add("active");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientHeight + this.slider.scrollTop - offset;
    return (
      element.offsetTop + element.clientHeight <= lastVisibleSlide &&
      element.offsetTop >= this.slider.scrollTop
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollTop + step * this.sliderItemOffset
        : this.slider.scrollTop - step * this.sliderItemOffset;
    this.slider.scrollTo({
      top: this.slideScrollPosition,
    });
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("vertical-slider-component", VerticalSliderComponent);

/*=========================
  PI Recently Viewed Products
===========================*/

class PIRecentlyViewed extends HTMLElement {
  constructor() {
    super();
    this.currentHandle = this.dataset.productHandle;
    this.storage = new PIStorage("pi-recently-viewed");
    this.htmlEl = this.querySelector("[data-products-html]");
  }
  connectedCallback() {
    this.prodductHandles = this.storage.get();
    this.prodductHandles = this.prodductHandles.filter(
      (item) => item.handle !== this.currentHandle
    );

    if (this.prodductHandles && this.prodductHandles.length >= 1) {
      this.initRecentlyViewed();
    } else {
      this.setAttribute("hidden", "");
    }
  }

  initRecentlyViewed() {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadPiRecentlyViewed();
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px 400px 0px" }
    );
    this.observer.observe(this);
  }

  async getProductHtml(handle) {
    console.log("Fetching product html");
    const fetchData = await fetch(
      `/products/${handle}/?section_id=pi-recently-viewed-card-product-section`
    );
    const response = await fetchData.text();
    const doc = new DOMParser().parseFromString(response, "text/html");
    const productEl = doc.querySelector("[data-pi-html]");
    return productEl.innerHTML;
  }

  async loadPiRecentlyViewed() {
    const htmlArray = await Promise.all(
      this.prodductHandles.map((product, index) =>
        this.getProductHtml(product.handle)
      )
    );

    this.htmlEl.innerHTML = htmlArray.join("");
    this.innerHTML = this.innerHTML;

    this.removeAttribute("hidden");
  }
}

customElements.define("pi-recently-viewed", PIRecentlyViewed);

document.addEventListener("DOMContentLoaded", function () {
  const headerDrawerClose = document.querySelector(
    "[data-header-drawer-close]"
  );

  if (headerDrawerClose) {
    headerDrawerClose.addEventListener("click", function () {
      document.body.classList.remove(
        "overflow-hidden-mobile",
        "overflow-hidden-tablet",
        "overflow-hidden-desktop"
      );
    });
  }
});

class PISELECT extends HTMLElement {
  constructor() {
    super();
    this.masterSelect = this.querySelector("select");
    this.piSelectedValue = this.querySelector("[pi-select-selected-value]");
    this.piOptions = this.querySelectorAll("[pi-select-item]");
    this.piOptions.forEach((option) => {
      option.addEventListener("click", this.onOptionClick.bind(this));
    });
    this.details = this.querySelector("details");
  }

  onOptionClick(event) {
    event.preventDefault();
    const option = event.currentTarget;
    const value = option.getAttribute("data-value");
    this.piSelectedValue.innerHTML = option.innerHTML;
    this.masterSelect.value = value;
    this.masterSelect.dispatchEvent(
      new CustomEvent("input", { bubbles: true })
    );
    if (this.details && !this.hasAttribute("change-outer-selector")) {
      this.details.removeAttribute("open");
    }
    // Extera event for changing outer selector
    if (this.hasAttribute("change-outer-selector")) {
      const outerSelected = document.querySelector(
        this.getAttribute("change-outer-selector")
      );
      if (outerSelected) {
        outerSelected.innerHTML = option.innerHTML;
        document.dispatchEvent(new CustomEvent("close:pi-tab-panel"));
      }
    }
  } // onOptionClick
}

customElements.define("pi-select", PISELECT);

class VariantPicker extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="id"]');
    this.onVariantInputClickListener = this.onVariantInputClick.bind(this);
    this.cardProduct = this.closest("pi-product-card");
  }

  connectedCallback() {
    this.querySelectorAll("fieldset .variant-input-js").forEach((button) => {
      button.addEventListener("click", this.onVariantInputClickListener);
    });
  }

  disconnectedCallback() {
    this.querySelectorAll("fieldset .variant-input-js").forEach((button) => {
      button.removeEventListener("click", this.onVariantInputClickListener);
    });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("fieldset .variant-input-js.pi-variant-selected"),
      (button) => button.dataset.value
    );
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  onVariantInputClick(event) {
    const btn = event.currentTarget;
    const fieldset = btn.closest("fieldset");
    fieldset.querySelectorAll(".variant-input-js").forEach((button) => {
      button.classList.remove("pi-variant-selected");
    });
    btn.classList.add("pi-variant-selected");
    this.onVariantChange();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    if (this.currentVariant) {
      this.input.value = this.currentVariant.id;
      if (this.currentVariant.available) {
        this.dispatchEvt();
      }
    }
  }
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  dispatchEvt() {
    if (this.cardProduct) {
      this.cardProduct.dispatchEvent(new CustomEvent("pi-product:addtocart"));
    }
  }
}

customElements.define("pi-variant-picker", VariantPicker);

class InternalVideo extends HTMLElement {
  constructor() {
    super();

    // Initialize element references
    this.playButton = this.querySelector(".internal-video__play");
    this.autoplay = this.dataset.autoplay === "true";
    this.video = this.querySelector("video");
    this.soundButton = this.querySelector(".internal-video__sound-btn");
    this.timeline = this.querySelector(".internal-video__timeline");

    // Initialize state
    this.loaded = false;
    this.playing = false;
    this.dragging = false;

    // Remove invalid format sources if any
    const invalidFormatSrc = this.video?.querySelector(
      'source[type="invalid"]'
    );
    if (invalidFormatSrc) {
      invalidFormatSrc.remove();
    }

    // Bind event listeners
    this.bindEvents();

    // Setup intersection observer for autoplay
    if (this.dataset.autoplay === "true" && "IntersectionObserver" in window) {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05,
      };

      this.observer = new IntersectionObserver(
        this.handleIntersection.bind(this),
        options
      );
      this.observer.observe(this);
    }
  }

  bindEvents() {
    // Play button events
    if (this.playButton) {
      this.playButton.addEventListener("click", this.togglePlay.bind(this));
    }

    // Sound button events
    if (this.soundButton) {
      this.soundButton.addEventListener("click", this.toggleSound.bind(this));
    }

    // Video events
    if (this.video) {
      this.video.addEventListener("ended", this.endedVideo.bind(this));
      this.video.addEventListener("timeupdate", this.updateTimeline.bind(this));
      this.video.addEventListener("waiting", this.showSpinner.bind(this));
      this.video.addEventListener("playing", this.hideSpinner.bind(this));
      this.video.addEventListener("pause", this.hideSpinner.bind(this));
    }

    // Timeline events
    if (this.timeline) {
      this.timeline.addEventListener("click", this.seekVideo.bind(this));
      this.timeline.addEventListener(
        "mousedown",
        this.startDragging.bind(this)
      );
      this.timeline.addEventListener(
        "touchstart",
        this.startDragging.bind(this)
      );

      // Document-level events for drag tracking
      document.addEventListener("mouseup", this.stopDragging.bind(this));
      document.addEventListener("touchend", this.stopDragging.bind(this));
      document.addEventListener("mousemove", this.handleDrag.bind(this));
      document.addEventListener("touchmove", this.handleDrag.bind(this));
    }
  }

  togglePlay() {
    if (!this.video) return;

    if (this.video.paused) {
      const playPromise = this.video.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            this.classList.add("internal-video--playing");
            if (this.playButton && this.autoplay) {
              this.playButton.style.visibility = "hidden";
            }
          })
          .catch((error) => {
            this.classList.remove("internal-video--playing");
            if (this.playButton && this.autoplay) {
              this.playButton.style.visibility = "visible";
            }
            console.error("Error playing video:", error);
          });
      }
    } else {
      this.video.pause();
      this.classList.remove("internal-video--playing");
    }
  }

  toggleSound() {
    if (!this.video) return;

    this.video.muted = !this.video.muted;
    this.classList.toggle("internal-video--muted", this.video.muted);
  }

  updateTimeline() {
    if (!this.video || !this.timeline) return;

    const progress = (this.video.currentTime / this.video.duration) * 100;
    this.style.setProperty("--video-progress", `${progress}%`);
  }

  seekVideo(event) {
    if (!this.video || !this.timeline) return;

    const rect = this.timeline.getBoundingClientRect();
    const clickPosition = event.clientX - rect.left;
    const percentage = clickPosition / rect.width;
    this.video.currentTime = percentage * this.video.duration;
  }

  startDragging(event) {
    event.preventDefault();
    this.dragging = true;
    this.handleDrag(event);
  }

  stopDragging() {
    this.dragging = false;
  }

  handleDrag(event) {
    if (!this.dragging) return;

    const touchEvent = event.touches ? event.touches[0] : event;
    this.seekVideo(touchEvent);
  }

  showSpinner() {
    this.classList.add("internal-video--loading");
  }

  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }

  endedVideo() {
    this.classList.remove("internal-video--playing");
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Load video sources
        const sources = this.video.querySelectorAll("source[data-src]");
        sources.forEach((source) => {
          source.setAttribute("src", source.getAttribute("data-src"));
          source.removeAttribute("data-src");
        });

        // Load and play video
        this.video.load();
        const playPromise = this.video.play();

        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              this.classList.add("internal-video--playing");
              if (this.playButton && this.autoplay) {
                this.playButton.style.visibility = "hidden";
              }
            })
            .catch(() => {
              // Autoplay was prevented, show play button
              if (this.playButton) {
                this.playButton.style.visibility = "visible";
              }
            });
        }

        // Disconnect observer after loading
        this.observer.disconnect();
      }
    });
  }
}

// Register custom element
customElements.define("internal-video", InternalVideo);

// Be youre theme

class ShopTheLook extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.blockCount == 1) {
      return;
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600,
    });
  }

  init() {
    this.products = this.querySelector(".image-with-text__products");

    this.blocks = this.querySelectorAll(
      "lookbook-component [data-block-index]"
    );
    this.blocks.forEach((block) =>
      block.addEventListener("mouseenter", this.onEnterHandler.bind(this))
    );

    this.initSlider();
  }

  onEnterHandler(event) {
    if (this.flickity && typeof this.flickity.select === "function") {
      const index = parseInt(event.target.dataset.blockIndex);
      this.flickity.select(index);
    }
  }

  onFocusHandler(index) {
    this.blocks.forEach((block) => {
      block.classList.remove("focus");

      if (parseInt(block.dataset.blockIndex) === index) {
        block.classList.add("focus");
      }
    });
  }

  initSlider() {
    this.flickity = new Flickity(this.products, {
      accessibility: false,
      rightToLeft: theme.config.rtl,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      fade: true,
      setGallerySize: true,
      on: {
        ready: () => {
          this.onFocusHandler(0);
        },
        change: (index) => {
          this.onFocusHandler(index);
        },
      },
    });
  }
}

customElements.define("shop-the-look", ShopTheLook);

//// bundle

class BundleProducts extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: "is-hover",
      active: "is-active",
    };

    this.button = this.querySelector("button");
    if (this.button)
      this.button.addEventListener("click", this.onButtonClick.bind(this));

    this.blocks = this.querySelectorAll("[data-block-id]");
    this.blocks.forEach((block) =>
      block.addEventListener("mouseenter", this.onEnterHandler.bind(this))
    );
    this.blocks.forEach((block) =>
      block.addEventListener("mouseleave", this.onLeaveHandler.bind(this))
    );
  }

  onEnterHandler(event) {
    this.classList.add(this.classes.hover);
    const target = event.target;
    const blockId = target.dataset.blockId;

    this.blocks.forEach((block) => {
      if (block.dataset.blockId === blockId) {
        block.classList.add(this.classes.active);
      }
    });
  }

  onLeaveHandler() {
    this.classList.remove(this.classes.hover);
    this.blocks.forEach((block) => block.classList.remove(this.classes.active));
  }

  async onButtonClick(event) {
    event.preventDefault();
    const ids = this.querySelectorAll('[name="id"]');
    const items = [...ids].map((e) => ({ id: e.value, quantity: 1 }));

    try {
      this.button.setAttribute("disabled", true);
      this.button.classList.add("loading");

      // Dawn-specific cart handling
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items }),
      });

      const responseData = await response.json();

      if (responseData.description || responseData.status) {
        this.handleErrorMessage(
          responseData.description || "Error adding to cart"
        );
        return;
      }

      // Dawn's native cart update
      document.dispatchEvent(
        new CustomEvent("cart:update", {
          bubbles: true,
        })
      );

      // Optional: Redirect to cart page
      if (window.location.pathname !== "/cart") {
        window.location.href = "/cart";
      }
    } catch (error) {
      console.error("Error:", error);
      this.handleErrorMessage("Network error - please try again");
    } finally {
      this.button.classList.remove("loading");
      this.button.removeAttribute("disabled");
    }
  }

  handleErrorMessage(errorMessage = false) {
    const errorWrapper = this.querySelector(
      ".product-form__error-message-wrapper"
    );
    if (!errorWrapper) return;

    const errorElement = errorWrapper.querySelector(
      ".product-form__error-message"
    );
    errorWrapper.toggleAttribute("hidden", !errorMessage);

    if (errorMessage && errorElement) {
      errorElement.textContent = errorMessage;
    }
  }
}

customElements.define("bundle-products", BundleProducts);


class PIDropdownMenu extends HTMLElement {
  constructor() {
    super();
    
    // Element references
    this.toggle = null;
    this.menu = null;
    this.isOpen = false;
    this.quantityInput = null;
    
    // Bind methods
    this.handleToggleClick = this.handleToggleClick.bind(this);
    this.handleItemClick = this.handleItemClick.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.updateToggleText = this.updateToggleText.bind(this);
  }
  
  connectedCallback() {
    this.toggle = this.querySelector('.dropdown__toggle');
    this.menu = this.querySelector('.dropdown__menu');
    this.quantityInput = this.querySelector('.quantity__input');
    this.toggleLabel = this.querySelector('.dropdown__label');
    
    if (!this.toggle || !this.menu) return;
  
    // Add event listeners
    this.toggle.addEventListener('click', this.handleToggleClick);
  
    // Add click listeners for all dropdown items
    const items = this.querySelectorAll('.dropdown__item a');
    items.forEach(item => {
      item.addEventListener('click', (e) => this.handleItemClick(e));
    });
  
    // Add input change listener
    if (this.quantityInput) {
      this.quantityInput.addEventListener('change', this.updateToggleText);
      this.updateToggleText(); // Initialize
    }
  
    // ✅ Listen for variant change and reset quantity
    this.variantSelect = this.closest('product-form')?.querySelector('[name="id"]');
    if (this.variantSelect) {
      this.variantSelect.addEventListener('change', () => {
        if (this.quantityInput) {
          this.quantityInput.value = 1;
          this.updateToggleText();
          const changeEvent = new Event('change', { bubbles: true });
          this.quantityInput.dispatchEvent(changeEvent);
        }
      });
    }
  
    // Global click listener
    document.addEventListener('click', this.handleClickOutside);
  }
  
  
  disconnectedCallback() {
    // Clean up event listeners
    if (this.toggle) {
      this.toggle.removeEventListener('click', this.handleToggleClick);
    }
    
    const items = this.querySelectorAll('.dropdown__item a');
    items.forEach(item => {
      item.removeEventListener('click', this.handleItemClick);
    });
    
    if (this.quantityInput) {
      this.quantityInput.removeEventListener('change', this.updateToggleText);
    }
    
    document.removeEventListener('click', this.handleClickOutside);
  }
  
  updateToggleText() {
    if (this.toggleLabel && this.quantityInput) {
      this.toggleLabel.textContent = `QTY ${this.quantityInput.value}`;
    }
  }
  
  handleToggleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    if (this.isOpen) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }
  
  handleItemClick(event) {
    event.preventDefault();
    // If the item has a data-quantity attribute, set the input value
    const quantity = event.currentTarget.getAttribute('data-quantity');
    if (quantity && this.quantityInput) {
      this.quantityInput.value = quantity;
      
      // Trigger change event so any Shopify listeners are notified
      const changeEvent = new Event('change', { bubbles: true });
      this.quantityInput.dispatchEvent(changeEvent);
      
      // Update the toggle text
      this.updateToggleText();
    }
    // Close dropdown when an item is clicked
    this.closeDropdown();
  }
  
  handleClickOutside(event) {
    // Special handling for the input - don't close when interacting with it
    if (event.target === this.quantityInput) {
      return;
    }
    
    // Close dropdown when clicking outside
    if (this.isOpen && !this.contains(event.target)) {
      this.closeDropdown();
    }
  }
  
  openDropdown() {
    this.isOpen = true;
    this.toggle.setAttribute('aria-expanded', 'true');
    this.menu.classList.add('dropdown__menu--open');
  }
  
  closeDropdown() {
    this.isOpen = false;
    this.toggle.setAttribute('aria-expanded', 'false');
    this.menu.classList.remove('dropdown__menu--open');
  }
}
// Register the custom element
customElements.define('pi-dropdown-menu', PIDropdownMenu); 

/* Delight Styler — retain selected product quantity after refresh */
(() => {
  const quantitySelector =
    'input[name="quantity"][data-ds-persist-quantity]';

  function getStorageKey(input) {
    return `ds-product-quantity:${input.dataset.dsPersistQuantity}`;
  }

  function getValidQuantity(input, rawValue) {
    const minimum =
      parseInt(input.min || input.dataset.min || '1', 10) || 1;

    const maximum = parseInt(
      input.max || input.dataset.max || '',
      10
    );

    let quantity = parseInt(rawValue, 10);

    if (!Number.isFinite(quantity)) {
      quantity = minimum;
    }

    quantity = Math.max(minimum, quantity);

    if (Number.isFinite(maximum)) {
      quantity = Math.min(maximum, quantity);
    }

    return quantity;
  }

  function saveQuantity(input) {
    try {
      const quantity = getValidQuantity(input, input.value);

      input.value = quantity;

      sessionStorage.setItem(
        getStorageKey(input),
        String(quantity)
      );
    } catch (error) {
      // Quantity continues working normally if storage is unavailable.
    }
  }

  function restoreQuantity(input) {
    if (
      input.dataset.dsQuantityPersistenceReady === 'true'
    ) {
      return;
    }

    input.dataset.dsQuantityPersistenceReady = 'true';

    try {
      const savedQuantity = sessionStorage.getItem(
        getStorageKey(input)
      );

      if (savedQuantity === null) return;

      input.value = getValidQuantity(
        input,
        savedQuantity
      );

      input.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    } catch (error) {
      // Keep Shopify's normal default quantity.
    }
  }

  function initializeQuantityInputs(root = document) {
    if (
      root.matches &&
      root.matches(quantitySelector)
    ) {
      restoreQuantity(root);
    }

    if (root.querySelectorAll) {
      root
        .querySelectorAll(quantitySelector)
        .forEach(restoreQuantity);
    }
  }

  document.addEventListener('input', (event) => {
    if (event.target.matches(quantitySelector)) {
      saveQuantity(event.target);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches(quantitySelector)) {
      saveQuantity(event.target);
    }
  });

  document.addEventListener(
    'DOMContentLoaded',
    () => initializeQuantityInputs(document)
  );

  window.addEventListener(
    'pageshow',
    () => initializeQuantityInputs(document)
  );

  const quantityObserver = new MutationObserver(
    (mutationRecords) => {
      mutationRecords.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            initializeQuantityInputs(node);
          }
        });
      });
    }
  );

  quantityObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();